"use strict";
/*
 * Created on 05 09 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * <p>
 * Encapsulates computed evaluation indicators of {@link SelloutReleaseItem release item} within running {@link SelloutRelease release}.
 * Data should be synced only between days {@link FinalProductPrice#validFrom} and {@link FinalProductPrice#.validTo}.
 * </p>
 *
 * <ul>
 *     <li>This entity includes mainly computed values.</li>
 *     <li>Expected forecast for new sellout price is taken from {@link SelloutReleaseItemPrices#forecastNewForOneDay}.</li>
 *     <li>Actual stock amount is encapsulated by {@link SelloutReleaseItemSupplyData}, same object encapsulates state of stock amount
 *         before repricing (before new price is about to start to be valid).</li>
 *     <li>Start of price validity should correspond with {@link FinalProductPrice#validFrom}.</li>
 * </ul>
 *
 * <p>
 * When regular release evaluation will be implemented, consider to create abstract entity from this.
 * </p>
 *
 * <p>
 * <b>The releases, for which sellout supplies are missing within external system (e.g. Returnable items), can be evaluated, but only
 * {@link #actualSalesAmount} will be filled.</b>
 * </p>
 *
 * @author JMe
 */


var SelloutReleaseItemEvaluation =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleaseItemEvaluation, _DomainObject_1$Domai);

  /**
   * @param expectedSalesAmount expected sales amount with respect to value of {@link SelloutReleaseItemPrices#forecastNewForOneDay} and
   *        computation day (e.g. original forecast was 40 for one day, it is third evaluation day -> expected sales amount would be 120).
   *        Value may be null if forecast for new price has not been set.
   * @param actualSalesAmount actual sales amount computed as sum of non promo sales transactions valid to the computation day.
   * @param estimationInPercent ratio of this#actualSalesAmount and this#expectedSalesAmount expressed as percentage number. Value may
   *        be null if forecast for new price has not been set.
   * @param estimatedEndDate estimated new end date. Takes into account actual stock amount and original expected forecast. Value may be
   *        null if forecast for new price has not been set.
   * @param estimatedDays number of estimated (remaining) days for which stock amount should be sold out, computed as days between
   *        estimated end date and current date (presumes that sync is till the end of validity of price, not further). Value may be null
   *        if forecast for new price has not been set.
   */
  function SelloutReleaseItemEvaluation(expectedSalesAmount, actualSalesAmount, estimationInPercent, estimatedEndDate, estimatedDays) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemEvaluation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemEvaluation).call(this));
    _this.expectedSalesAmount = expectedSalesAmount;
    _this.actualSalesAmount = actualSalesAmount;
    _this.estimationInPercent = estimationInPercent;
    _this.estimatedEndDate = estimatedEndDate;
    _this.estimatedDays = estimatedDays;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(SelloutReleaseItemEvaluation, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutReleaseItemEvaluation(mat.expectedSalesAmount, mat.actualSalesAmount, mat.estimationInPercent, mat.estimatedEndDate, mat.estimatedDays);
    }
  }]);

  return SelloutReleaseItemEvaluation;
}(DomainObject_1.DomainObject);

exports.SelloutReleaseItemEvaluation = SelloutReleaseItemEvaluation;

SelloutReleaseItemEvaluation.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutReleaseItemEvaluation.name);
  return {
    expectedSalesAmount: builder.opt(builder.bigNum('expectedSalesAmount')),
    actualSalesAmount: builder.bigNum('actualSalesAmount'),
    estimationInPercent: builder.opt(builder.bigNum('estimationInPercent')),
    priceValidFrom: builder.date('priceValidFrom', DateParser_1.DateParser.ISO_PATTERN),
    estimatedEndDate: builder.opt(builder.date('estimatedEndDate', DateParser_1.DateParser.ISO_PATTERN)),
    estimatedDays: builder.opt(builder.num('estimatedDays'))
  };
}();